import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { GlobalModal } from "../../components/authModals";
import MainHeader from "../Main/MainHeader";
import Header from "../Main/Header";
import Footer from "../Main/Footer";

const AuthLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const token = localStorage.getItem("token") || sessionStorage.getItem("token");

  useEffect(() => {
    const isValidToken = token && token !== "undefined" && token !== "null" && token.trim() !== "";

    if (isValidToken) {
      navigate("/create-game");
    }
  }, [token, location.pathname, navigate]);

  return (
    <>
      <GlobalModal />
      {token ? <MainHeader /> : <Header />}
      <Outlet />
      <Footer />
    </>
  );
};

export default AuthLayout;
